<template>
    <BaseDialog
        :showDialog="showYearOfExpirationDialog"
        maxDialogWidth="600"
        maxCardHeight="900"
        headline="lang_PUBLISHING_WORKS_NOSHARES_DIALOG_HEADLINE"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid class="py-6">
                <v-row>
                    <v-col>
                        <DropdownFilter 
                            :context="context"
                            label="lang_GENERIC_CAPTION_YEAR_OF_EXPIRATION"
                            itemText="text"
                            class="mx-4"
                            :items="yearsOptions"
                            :hideErrorMessage="false"
                            :alvqa="alvqa + '-dropdown-track-years-filter'"
                        /> 
                    </v-col>
                </v-row>

            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import DropdownFilter from '@/components/_filters/DropdownFilter'


export default {
    name: "YearOfExpirationDialog",
    components: {
        BaseDialog,

        DropdownFilter
    },
    data() {
        return {
            context: "YearOfExpiration",
            alvqa: 'publishing-works-list-dialog-year-of-expiration',
        }
    },
    computed: {
        showYearOfExpirationDialog: {
            get() { return this.$store.getters.getShowYearOfExpirationDialog },
            set(show) { this.$store.commit('setShowYearOfExpirationDialog', show) }
        },
        yearsOptions(){
            let years = [];
            let startYear = new Date().getFullYear()
            let endYear = startYear + 31;
            for(let i = startYear; i < endYear; i++) {
                years.push(
                    {
                        text: i.toString(),
                        value: i, 
                        alvqa: this.alvqa + '-dropdown-period-selector-years-' + i
                    }
                )
            } 
            return years
            
        }, 
    },
    methods: {
        closeDialog() {
            if(this.$store.getters.getSelectedYearOfExpiration == null || this.$store.getters.getSelectedYearOfExpiration == 0){
                this.$store.commit("setSelectedWorksQualityFilter",[])
                this.$store.commit("setSelectedYearOfExpiration", 0)
                this.$store.commit('setSnackbar', {
                    type: 'error',
                    msg: this.$t('lang_PUBLISHING_WORKS_NOSHARES_FILTER_NO_OPTIONS_CHOOSEN')
                })
            }
            this.showYearOfExpirationDialog = false
        },
    }

}
</script>
<style>
/** CHECK IF IT IS OK TO MOVE TO GENERAL CSS */
label.v-label--is-disabled.theme--light span {
    color: inherit!important;
}
</style>